import { useContext } from "react";
import { RoomContext } from "./RoomContext";
import type { RoomPeer } from "./peer-state";

export function usePeers(): RoomPeer[] {
  const ctx = useContext(RoomContext);
  if (!ctx) throw new Error("usePeers must be used within RoomProvider");
  return ctx.peers;
}
